import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import Sidebar from '../components/Sidebar'

export default withRouter(
  connect(
    createStructuredSelector<ApplicationState, ICurrentUserState>({
      user: selectCurrentUser(),
    }),
    {},
  )(Sidebar),
)
